module.exports = __webpack_public_path__ + "static/media/cross.2e3da108.svg";